export const SEO_URL_META_DATA = 'https://www.xing.com/people/cities/';
